export type AvailabilityWindow = {
  availableFrom?: string;
  availableUntil?: string;
};

export function torontoDateOnly(date = new Date()) {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Toronto",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);
  const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${values.year}-${values.month}-${values.day}`;
}

export function isWithinAvailability(
  item: AvailabilityWindow,
  today = torontoDateOnly(),
) {
  return (
    (!item.availableFrom || today >= item.availableFrom) &&
    (!item.availableUntil || today <= item.availableUntil)
  );
}

export function isAfterAccessEnd(accessEndsOn?: string, today = torontoDateOnly()) {
  return Boolean(accessEndsOn && today > accessEndsOn);
}
